import React from 'react'
import './Footer.css'
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import FacebookIcon from '@material-ui/icons/Facebook';

function Footer() {
    return (
        <div className='foot'>
           <h4>@ Siddharth Shetty</h4>
           <div className='icon'>
           <a href='https://www.facebook.com/siddharth.shetty.5876'
           className='fb social'>
               <FacebookIcon/>
               </a>
           <a href='https://www.instagram.com/the_notorious97/'
           className='insta social'>
               <InstagramIcon/>
               </a>
               <a href='https://www.linkedin.com/in/siddharth-shetty-ba3b38188'
           className='linkedin social'>
               <LinkedInIcon/>
               </a>
           </div>
        

        </div>
    )
}

export default Footer
